let scope: Set<HTMLCanvasElement> | null = null;
let cleanups: Array<() => void> | null = null;

export function onCanvasScopeEnd(cleanup: () => void): void {
  cleanups?.push(cleanup);
}

export function trackCanvas(canvas: HTMLCanvasElement): HTMLCanvasElement {
  scope?.add(canvas);
  return canvas;
}

export function isCanvasMemoryScopeActive(): boolean {
  return scope !== null;
}

export function retainScopedCanvas(canvas: HTMLCanvasElement): void {
  scope?.delete(canvas);
}

/** Only releases surfaces allocated by the active PNG operation, never assets. */
export function releaseScopedCanvas(source: CanvasImageSource): void {
  const canvas = source as HTMLCanvasElement;
  if (!scope?.delete(canvas)) return;
  canvas.width = 1;
  canvas.height = 1;
}

/** Synchronous composition only: async asset loads happen before this scope. */
export function withCanvasMemoryScope(operation: () => HTMLCanvasElement): HTMLCanvasElement {
  const previous = scope;
  const previousCleanups = cleanups;
  const owned = new Set<HTMLCanvasElement>();
  scope = owned;
  const callbacks: Array<() => void> = [];
  cleanups = callbacks;
  let output: HTMLCanvasElement | null = null;
  try {
    output = operation();
    return output;
  } finally {
    try {
      callbacks.forEach(cleanup => cleanup());
    } catch (error) {
      output = null;
      throw error;
    } finally {
      owned.forEach(canvas => {
        if (canvas === output) return;
        canvas.width = 1;
        canvas.height = 1;
      });
      owned.clear();
      scope = previous;
      cleanups = previousCleanups;
      if (output) previous?.add(output);
    }
  }
}
